<div class="articles-sorter-wrapper" *ngIf="block.data.displayFilters">
    <div class="container-lg">
        <div class="col-lg-12 col-xl-10 mx-auto d-none d-lg-block">
            <div class="btn btn-article active" (click)="filterArticlesAll($event)">Show all</div>
            <div *ngFor="let category of this.headlineCategories"
                 (click)="filterArticles(category)"
                 class="btn btn-article" [attr.id]="category">
                {{category}}s
            </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-center d-lg-none">
            <select class="custom-select" (change)="filterArticlesMobile($event)">
                <option value="" disabled>Filter articles</option>
                <option value="*">All</option>
                <ng-container *ngFor="let category of this.headlineCategories">
                    <option [value]="category">{{category}}s</option>
                </ng-container>
            </select>
        </div>
    </div>
</div>

<div class="articles-wrapper-outer">
    <div class="container-lg d-flex justify-content-center">
        <core-spinner name="articles"></core-spinner>
<!--        <isotope-grid class="grid row gx-3" [options]="{}" id="articles" *ngIf="allHeadlinePages">-->
<!--            <isotope-item class="col-xs-12 col-sm-12 col-md-6 col-lg-4 card-tile" *ngFor="let feedpost of allHeadlinePages; trackBy: trackByFn" [ngClass]="feedpost.meta.headlineCategory">-->
<!--                <a [routerLink]="feedpost.meta.redirect || '/' + feedpost.url" class="card-tile__wrapper">-->
<!--                    <img class="card-tile__image" [src]="feedpost.meta.icon | cdn" [alt]="feedpost.name">-->
<!--                    <div class="card-tile__content">-->
<!--                        <div class="card-tile__title">-->
<!--                            <h3>{{feedpost.name}}</h3>-->
<!--                        </div>-->
<!--                        <div class="card-tile__excerpt">-->
<!--                            <p>{{feedpost.description}}</p>-->
<!--                        </div>-->

<!--                        <div class="card-tile__link">-->
<!--                            <a [attr.aria-label]="feedpost.meta.url"-->
<!--                               [routerLink]="feedpost.meta.redirect || '/' + feedpost.url">Learn more<svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M9.17756 0.343946C9.27051 0.360087 9.36009 0.40531 9.43721 0.482689L12.5153 3.56081C12.7071 3.75261 12.7071 4.06272 12.5153 4.25452L9.43721 7.33264C9.12871 7.64216 8.60079 7.42215 8.60079 6.98578V4.92247H1.09121C0.956738 4.92437 0.823225 4.89953 0.698437 4.84939C0.573647 4.79924 0.46007 4.72479 0.364303 4.63037C0.268536 4.53595 0.19249 4.42343 0.140584 4.29937C0.0886793 4.1753 0.0619507 4.04215 0.0619507 3.90767C0.0619507 3.77318 0.0886793 3.64003 0.140584 3.51596C0.19249 3.3919 0.268536 3.27938 0.364303 3.18496C0.46007 3.09054 0.573647 3.01609 0.698437 2.96594C0.823225 2.9158 0.956738 2.89096 1.09121 2.89286H8.60079V0.829547C8.60079 0.50151 8.89871 0.29552 9.17756 0.343946Z" fill="black"/>-->
<!--                            </svg>-->
<!--                            </a>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                </a>-->
<!--            </isotope-item>-->
<!--        </isotope-grid>-->
    </div>
</div>

<div class="card-tiles-showall-wrapper" *ngIf="block.data.hasShowAllButton">
    <div class="container">
        <div class="card-tiles-showall-btn text-center">
            <a class="btn btn-primary" [routerLink]="'/' + block.data.showAllButtonLink" [target]="block.data.showallButtonTarget">{{block.data.showAllButtonText}}</a>
        </div>
    </div>
</div>
